import { Button } from 'foundations-components/transitional/components/Button';
import RouterButton from 'ui-addon-react-router-dom/RouterButton';
import { useShouldReloadLocation } from '../hooks/useShouldReloadLocation';
import { useReloadLinkProps } from '../hooks/useReloadLinkProps';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * App-aware drop-in for `RouterButton`. Renders a Trellis `Button` with a full
 * page reload for cross-app navigation, or a `RouterButton` for same-app
 * navigation.
 *
 * @param href - Optional override for the resolved href. Only used during
 *   cross-app navigation (full page reload). Has no effect for same-app
 *   navigation, where `to` is used instead.
 */
export const ACRouterButton = props => {
  const {
    href,
    handleClick
  } = useReloadLinkProps(props);
  const shouldReload = useShouldReloadLocation(props.to);
  if (shouldReload) {
    return /*#__PURE__*/_jsx(Button, Object.assign({}, props, {
      href: href,
      onClick: handleClick
    }));
  }
  return /*#__PURE__*/_jsx(RouterButton, Object.assign({}, props, {
    href: undefined
  }));
};